module.exports = __webpack_public_path__ + "img/mapbg.2b1100f1.png";